<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da tela -->
          <basic-toolbar :title="'Editar Relatório Técnico de Extensão ' + this.relatorioExtensao.ordem"></basic-toolbar>
          <v-card-text>

            <!-- Mensagem informativa -->
            <v-layout row wrap text-xs-left>
              <v-flex xs12>
                <v-alert class="alertaEdicao" dense type="info" color="#00796b" outlined>
                  Em caso de dúvidas ou sugestões entrar em contato pelo e-mail <a
                    href="mailto:suporte.proex@ufes.br">suporte.proex@ufes.br</a>. Já em caso de problemas com o sistema
                  entrar em contato pelo <a href="https://redmine.ufes.br/projects/suporte-projetos-extensao/issues/new"
                    target="_blank">Sistema de Suporte</a>.
                </v-alert>
              </v-flex>
            </v-layout>

            <!-- Título -->
            <v-layout row>
              <v-flex xs12>
                <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.tituloAcaoExtensao !== null"
                  label="Título" :value="this.relatorioExtensao.tituloAcaoExtensao"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="Título" value="-"></c-readonly-field>
              </v-flex>
            </v-layout>

            <!-- Nome do coordenador -->
            <v-layout row>
              <v-flex xs12>
                <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.nomeCoordenador !== null"
                  label="Nome do coordenador" :value="this.relatorioExtensao.nomeCoordenador"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="Nome do coordenador" value="-"></c-readonly-field>
              </v-flex>
            </v-layout>

            <!-- Número e Tipo -->
            <v-layout row>
              <!-- Número -->
              <v-flex xs6>
                <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.numeroAcaoExtensao !== null"
                  label="Número" :value="this.relatorioExtensao.numeroAcaoExtensao"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="Número" value="-"></c-readonly-field>
              </v-flex>
              <!-- Tipo -->
              <v-flex xs6>
                <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.tipoAcaoExtensao !== null"
                  label="Tipo" :value="this.relatorioExtensao.tipoAcaoExtensao"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="Tipo" value="-"></c-readonly-field>
              </v-flex>
            </v-layout>

            <!-- Unidade -->
            <v-layout row>
              <v-flex xs12>
                <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.unidade !== null" label="Unidade"
                  :value="this.relatorioExtensao.unidade"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="Unidade" value="-"></c-readonly-field>
              </v-flex>
            </v-layout>

            <!-- E-mail do coordenador -->
            <v-layout row>
              <v-flex xs12>
                <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.emailCoordenador !== null"
                  label="E-mail do coordenador" :value="this.relatorioExtensao.emailCoordenador"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="E-mail do coordenador"
                  value="-"></c-readonly-field>
              </v-flex>
            </v-layout>

            <!-- Liberação de carga horária do coordenador e Carga horária -->
            <v-layout row>
              <!-- Liberação de carga horária do coordenador -->
              <v-flex xs6>
                <c-readonly-field class="textoRelatorio"
                  v-if="this.relatorioExtensao.liberacaoCargaHorariaCoordenador !== null"
                  label="Liberação de carga horária do coordenador"
                  :value="this.relatorioExtensao.liberacaoCargaHorariaCoordenador == true ? 'Sim' : 'Não'"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="Liberação de carga horária do coordenador"
                  value="-"></c-readonly-field>
              </v-flex>
              <!-- Carga horária -->
              <v-flex xs6>
                <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.cargaHorariaCoordenador !== null"
                  label="Carga horária" :value="this.relatorioExtensao.cargaHorariaCoordenador"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="Carga horária" value="-"></c-readonly-field>
              </v-flex>
            </v-layout>

            <!-- Relatório Técnico Final de cursos/oficinas (39729), cursos (44194), oficinas (44195) e eventos (39730) -->
            <v-layout row
              v-if="(projeto.classificacaoSecundaria.id === 39729 || projeto.classificacaoSecundaria.id === 44194 || projeto.classificacaoSecundaria.id === 44195 || projeto.classificacaoSecundaria.id === 39730) && relatorioExtensao.tipoRelatorioTecnicoItem === 3">

              <!-- Houve mudança nas datas de início e/ou de conclusão da ação de extensão? -->
              <v-flex xs12>
                <c-readonly-field class="textoRelatorio" v-if="this.relatorioExtensao.mudancaDatasAcao !== null"
                  label="Houve mudança nas datas de início e/ou de conclusão da ação de extensão?"
                  :value="this.relatorioExtensao.mudancaDatasAcao === 'S' ? 'Sim' : 'Não'"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else
                  label="Houve mudança nas datas de início e/ou de conclusão da ação de extensão?"
                  value="-"></c-readonly-field>
              </v-flex>

              <!-- Justificativa -->
              <v-flex xs12 v-if="this.relatorioExtensao.mudancaDatasAcao === 'S'">
                <c-readonly-field class="textoRelatorio"
                  v-if="this.relatorioExtensao.justificativaMudancaDatasAcao !== null" label="Justificativa"
                  :value="this.relatorioExtensao.justificativaMudancaDatasAcao"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="Justificativa" value="-"></c-readonly-field>
              </v-flex>

            </v-layout>

            <!-- Período a que se refere o relatório -->
            <v-layout row wrap text-xs-left>
              <v-flex xs12>
                <label class="textoRelatorio">Período a que se refere o relatório</label>
              </v-flex>
            </v-layout>

            <br>

            <!-- Período do relatório para cursos/oficinas (39729), cursos (44194), oficinas (44195) e eventos (39730) -->
            <div
              v-if="projeto.classificacaoSecundaria.id === 39729 || projeto.classificacaoSecundaria.id === 44194 || projeto.classificacaoSecundaria.id === 44195 || projeto.classificacaoSecundaria.id === 39730">

              <!-- O administrador pode alterar o período do relatório -->
              <v-layout row text-xs-left v-if="administrador === true">
                <v-flex md5 xs12>
                  <v-text-field v-model="relatorioExtensao.dtInicial" type="date">
                    <template v-slot:label>
                      <span style="font-size: 1.25em">Início:</span>
                    </template>
                  </v-text-field>
                </v-flex>
                <v-flex md1></v-flex>
                <v-flex md5 xs12>
                  <v-text-field v-model="relatorioExtensao.dtFinal" type="date">
                    <template v-slot:label>
                      <span style="font-size: 1.25em">Fim:</span>
                    </template>
                  </v-text-field>
                </v-flex>
                <v-flex md1></v-flex>
              </v-layout>

              <!-- Usuário não é administrador -->
              <v-layout row text-xs-left v-if="administrador === null || administrador === false">
                <v-flex md5 xs12>
                  <c-readonly-field class="textoRelatorio" v-if="dtInicialFormatada !== null" label="Início:"
                    :value="dtInicialFormatada"></c-readonly-field>
                  <c-readonly-field class="textoRelatorio" v-else label="Início:" value="-"></c-readonly-field>
                </v-flex>
                <v-flex md1></v-flex>
                <v-flex md5 xs12>
                  <c-readonly-field class="textoRelatorio" v-if="dtFinalFormatada !== null" label="Fim:"
                    :value="dtFinalFormatada"></c-readonly-field>
                  <c-readonly-field class="textoRelatorio" v-else label="Fim:" value="-"></c-readonly-field>
                </v-flex>
                <v-flex md1></v-flex>
              </v-layout>

            </div>

            <!-- Período do relatório para programas (39733), projetos (39734) e prestações de serviço (39731) -->
            <div
              v-if="projeto.classificacaoSecundaria.id === 39733 || projeto.classificacaoSecundaria.id === 39734 || projeto.classificacaoSecundaria.id === 39731">

              <v-layout row text-xs-left>
                <v-flex md5 xs12>
                  <c-readonly-field class="textoRelatorio" v-if="dtInicialFormatada !== null" label="Início:"
                    :value="dtInicialFormatada"></c-readonly-field>
                  <c-readonly-field class="textoRelatorio" v-else label="Início:" value="-"></c-readonly-field>
                </v-flex>
                <v-flex md1></v-flex>
                <v-flex md5 xs12>
                  <c-readonly-field class="textoRelatorio" v-if="dtFinalFormatada !== null" label="Fim:"
                    :value="dtFinalFormatada"></c-readonly-field>
                  <c-readonly-field class="textoRelatorio" v-else label="Fim:" value="-"></c-readonly-field>
                </v-flex>
                <v-flex md1></v-flex>
              </v-layout>

            </div>

            <br>

            <!-- Situação do relatório -->
            <v-layout row wrap text-xs-left>
              <v-flex xs12>
                <c-readonly-field class="textoRelatorio" v-if="relatorioExtensao.situacaoRelatorioTecnicoItem !== null"
                  label="Situação do relatório"
                  :value="getSituacaoRelatorio(relatorioExtensao.situacaoRelatorioTecnicoItem)"></c-readonly-field>
                <c-readonly-field class="textoRelatorio" v-else label="Situação do relatório"
                  value="-"></c-readonly-field>
              </v-flex>
            </v-layout>

            <!-- Quando o relatório técnico está aprovado ou reprovado -->
            <div
              v-if="relatorioExtensao.situacaoRelatorioTecnicoItem !== null && (relatorioExtensao.situacaoRelatorioTecnicoItem === 3 || relatorioExtensao.situacaoRelatorioTecnicoItem === 4)">

              <!-- Relatório técnico aprovado -->
              <div
                v-if="relatorioExtensao.situacaoRelatorioTecnicoItem !== null && relatorioExtensao.situacaoRelatorioTecnicoItem === 3">

                <br>

                <!-- Data de aprovação do relatório pela Câmara de Extensão -->
                <v-layout row wrap text-xs-left
                  v-if="relatorioExtensao.situacaoRelatorioTecnicoItem !== null && relatorioExtensao.situacaoRelatorioTecnicoItem === 3">
                  <v-flex xs12>
                    <c-readonly-field class="textoRelatorio" v-if="relatorioExtensao.dtAprovacaoRelatorio !== null"
                      label="Data de aprovação do relatório pela Câmara de Extensão"
                      :value="dtAprovacaoFormatada"></c-readonly-field>
                    <c-readonly-field class="textoRelatorio" v-else
                      label="Data de aprovação do relatório pela Câmara de Extensão" value="-"></c-readonly-field>
                  </v-flex>
                </v-layout>

              </div>

              <!-- Relatório técnico reprovado -->
              <div
                v-if="relatorioExtensao.situacaoRelatorioTecnicoItem !== null && relatorioExtensao.situacaoRelatorioTecnicoItem === 4">

                <br>

                <!-- Data de reprovação do relatório pela Câmara de Extensão -->
                <v-layout row wrap text-xs-left
                  v-if="relatorioExtensao.situacaoRelatorioTecnicoItem !== null && relatorioExtensao.situacaoRelatorioTecnicoItem === 4">
                  <v-flex xs12>
                    <c-readonly-field class="textoRelatorio" v-if="relatorioExtensao.dtReprovacaoRelatorio !== null"
                      label="Data de reprovação do relatório pela Câmara de Extensão"
                      :value="dtReprovacaoFormatada"></c-readonly-field>
                    <c-readonly-field class="textoRelatorio" v-else
                      label="Data de reprovação do relatório pela Câmara de Extensão" value="-"></c-readonly-field>
                  </v-flex>
                </v-layout>

              </div>

              <br>

              <!-- Processo -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <c-readonly-field class="textoRelatorio" v-if="relatorioExtensao.processo !== null" label="Processo"
                    :value="relatorioExtensao.processo"></c-readonly-field>
                  <c-readonly-field class="textoRelatorio" v-else label="Processo" value="-"></c-readonly-field>
                </v-flex>
              </v-layout>

            </div>

            <br>

            <v-divider></v-divider>

            <br>

            <v-form v-model="formularioValido" ref="form">

              <!-- Tipo do relatório para cursos/oficinas (39729), cursos (44194), oficinas (44195) e eventos (39730) -->
              <div
                v-if="projeto.classificacaoSecundaria.id === 39729 || projeto.classificacaoSecundaria.id === 44194 || projeto.classificacaoSecundaria.id === 44195 || projeto.classificacaoSecundaria.id === 39730">

                <v-layout row wrap text-xs-left>
                  <v-flex xs12>
                    <v-radio-group v-model="relatorioExtensao.tipoRelatorioTecnicoItem" id="v-radio-group_label"
                      class="v-radio-group_label, item" :mandatory="true" label="Tipo do relatório">
                      <v-radio class="opcaoRadio" :value="3"
                        label="Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

                <br>

              </div>

              <!-- Tipo do relatório para programas (39733), projetos (39734) e prestações de serviço (39731) -->
              <div
                v-if="projeto.classificacaoSecundaria.id === 39733 || projeto.classificacaoSecundaria.id === 39734 || projeto.classificacaoSecundaria.id === 39731">

                <v-layout row wrap text-xs-left>
                  <v-flex xs12>
                    <v-radio-group v-model="relatorioExtensao.tipoRelatorioTecnicoItem" id="v-radio-group_label"
                      class="v-radio-group_label, item" :mandatory="true" label="Tipo do relatório">
                      <!-- <v-radio :value="1" label="Relatório Parcial: Deverá ser apresentado a cada 12 meses de atividade e encaminhado à ProEx no prazo máximo de 60 dias após o término do interstício."></v-radio> -->
                      <v-radio :value="2"
                        label="Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."></v-radio>
                      <!-- <v-radio :value="3" label="Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto." ></v-radio> -->
                    </v-radio-group>
                  </v-flex>
                </v-layout>

              </div>

              <!-- Mensagem exibida caso o usuário selecione relatório com renovação -->
              <div v-if="relatorioExtensao.tipoRelatorioTecnicoItem === 2">
                <v-layout row wrap text-xs-left>
                  <v-flex xs12>
                    <label>*Em caso de "Relatório Parcial com Renovação", é necessária a atualização das atividades e
                      outras informações relativas ao novo interstício de execução da ação.</label>
                  </v-flex>
                </v-layout>
                <br>
              </div>

              <!-- Nova data de conclusão da ação de extensão -->
              <!-- (caso o usuário selecione relatório com renovação) -->
              <div v-if="relatorioExtensao.tipoRelatorioTecnicoItem === 2">
                <v-layout row wrap text-xs-left>
                  <v-flex md5 xs12>
                    <br>
                    <label class="item">Nova data de conclusão da ação de extensão:</label>
                    <v-text-field v-model="relatorioExtensao.dtNovaConclusao" type="date" max-height="20">
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </div>

              <div v-if="relatorioForaPrazo === true || foraDoPrazo === true">
                <br>
              </div>

              <!-- Apresentar justificativa para envio do relatório fora do prazo. -->
              <v-layout row wrap text-xs-left v-if="relatorioForaPrazo === true || foraDoPrazo === true">
                <v-flex xs12>
                  <label class="item">Apresentar justificativa para envio do relatório fora do prazo:</label>
                  <v-textarea v-model="relatorioExtensao.justificativaForaPrazo" rows="1" auto-grow counter="500"
                    :rules="rules500">
                  </v-textarea>
                </v-flex>
              </v-layout>

              <!--
          1) A metodologia foi alterada para alcançar os objetivos da proposta inicial?
        -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <v-radio-group v-model="relatorioExtensao.opcao5"
                    label="1) A metodologia foi alterada para alcançar os objetivos da proposta inicial?"
                    id="v-radio-group_label" class="v-radio-group_label, item">
                    <v-radio class="opcaoRadio" label="Sim" value="S"></v-radio>
                    <v-radio class="opcaoRadio" label="Não" value="N"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>

              <v-layout row wrap text-xs-left v-if="relatorioExtensao.opcao5 === 'S'">
                <v-flex xs12>
                  <label class="textoRelatorio">Apresente sucintamente as alterações implementadas:</label>
                  <v-textarea :disabled="relatorioExtensao.opcao5 !== 'S'" v-model="relatorioExtensao.texto1" rows="1"
                    auto-grow counter="750" :rules="rules750">
                  </v-textarea>
                </v-flex>
              </v-layout>

              <br>

              <br>

              <!--
          2) Local de execução da ação.
        -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="item">2) Local de execução da ação:</label>
                  <v-textarea v-model="relatorioExtensao.texto2" rows="1" auto-grow counter="300" :rules="rules300">
                  </v-textarea>
                </v-flex>
              </v-layout>

              <br>

              <br>

              <!--
          3) Informar o quantitativo total de indivíduos beneficiados no período deste relatório.
        -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="item">3) Informar o quantitativo total de indivíduos beneficiados no período deste
                    relatório</label>
                  <v-alert class="alertaEdicao" dense type="info" color="#00796b" outlined>
                    Solicitamos atenção para que os registros de público-alvo reflitam a veracidade dos dados.
                  </v-alert>
                </v-flex>
              </v-layout>
              <br>
              <!-- 3.1 - Público-alvo direto. -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="textoRelatorio">3.1 - Público-alvo direto (público concretamente registrado):</label>
                  <v-text-field-integer v-model="relatorioExtensao.publicoAlvoDireto" :rules="numerico">
                  </v-text-field-integer>
                </v-flex>
              </v-layout>
              <!-- 3.2 - Público-alvo indireto. -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="textoRelatorio">3.2 - Público-alvo indireto (estimativa de público atingido
                    indiretamente):</label>
                  <v-text-field-integer v-model="relatorioExtensao.publicoAlvoIndireto" :rules="numerico">
                  </v-text-field-integer>
                </v-flex>
              </v-layout>

              <br>

              <br>

              <!--
          4) Atividades e resultados.
        -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="item">4) Atividades e resultados</label>
                </v-flex>
              </v-layout>

              <!-- Cards com as atividades -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <v-col v-for="(item, i) in relatorioExtensao.listaRelatorioAtividade" :key="i">
                    <v-card outlined>
                      <v-card-text>

                        <!-- Nome e descrição sucinta da atividade -->
                        <v-layout row wrap text-xs-left>
                          <v-flex xs12>
                            <c-readonly-field class="textoRelatorio" label="Nome e descrição sucinta da atividade"
                              :value="item.descricao">
                            </c-readonly-field>
                            <c-readonly-field v-if="item.detalhamento !== null && item.detalhamento !== ''"
                              class="textoRelatorio" :value="item.detalhamento">
                            </c-readonly-field>
                          </v-flex>
                        </v-layout>

                        <!-- Principal objetivo específico ao qual esta atividade está vinculada -->
                        <v-layout row wrap text-xs-left>
                          <v-flex xs12>
                            <c-readonly-field class="textoRelatorio"
                              label="Principal objetivo específico ao qual esta atividade está vinculada"
                              :value="item.objetivoEspecifico !== null && item.objetivoEspecifico !== '' ? item.objetivoEspecifico : '-'">
                            </c-readonly-field>
                          </v-flex>
                        </v-layout>

                        <!-- Situação -->
                        <v-layout row wrap text-xs-left>
                          <v-flex xs12>
                            <c-readonly-field v-if="item.situacaoAtividade !== null" class="textoRelatorio"
                              label="Situação" :value="situacaoAtividade.format(item.situacaoAtividade.item)">
                            </c-readonly-field>
                            <c-readonly-field v-if="item.situacaoAtividade === null" class="textoRelatorio"
                              label="Situação" value="-">
                            </c-readonly-field>
                          </v-flex>
                        </v-layout>

                        <!-- Datas de início efetivo e de conclusão efetiva -->
                        <v-layout row wrap text-xs-left>

                          <!-- Início efetivo -->
                          <v-flex md5 xs12>
                            <c-readonly-field class="textoRelatorio" label="Início efetivo"
                              :value="dates.format(item.dtInicioEfetivo)">
                            </c-readonly-field>
                          </v-flex>

                          <v-flex md1></v-flex>

                          <!-- Conclusão efetiva -->
                          <v-flex md5 xs12>
                            <c-readonly-field class="textoRelatorio" label="Conclusão efetiva"
                              :value="dates.format(item.dtFimEfetivo)">
                            </c-readonly-field>
                          </v-flex>

                          <v-flex md1></v-flex>

                        </v-layout>

                        <!-- Resultados -->
                        <v-layout row wrap text-xs-left>
                          <v-flex xs12>
                            <c-readonly-field class="textoRelatorio" label="Resultados"
                              :value="item.resultados !== null && item.resultados !== '' ? item.resultados : '-'">
                            </c-readonly-field>
                          </v-flex>
                        </v-layout>

                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-flex>
              </v-layout>

              <br>

              <br>

              <!--
          5) Discutir de forma geral a relevância das atividades, seu mérito extensionista, impacto, abrangência social, interdisciplinaridade e visibilidade.
        -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="item">5) Discutir de forma geral a relevância das atividades, seu mérito extensionista,
                    impacto, abrangência social, interdisciplinaridade e visibilidade:</label>
                  <v-textarea v-model="relatorioExtensao.texto4" rows="1" auto-grow counter="1000" :rules="rules1000">
                  </v-textarea>
                </v-flex>
              </v-layout>

              <br>

              <br>

              <!--
          6) Descrever de que maneira a ação de extensão contribuiu para a formação do aluno de graduação integrante da equipe.
        -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="item">6) Descrever de que maneira a ação de extensão contribuiu para a formação do aluno
                    de graduação integrante da equipe:</label>
                  <v-textarea v-model="relatorioExtensao.texto5" rows="1" auto-grow counter="500" :rules="rules500">
                  </v-textarea>
                </v-flex>
              </v-layout>

              <br>

              <br>

              <!--
          7) Relacionar os fatores que interferiram na execução da ação.
        -->
              <v-layout row wrap justify-center>
                <v-flex xs12>
                  <label class="item">7) Relacionar os fatores que interferiram na execução da ação</label>
                </v-flex>
              </v-layout>
              <br>
              <br>
              <!-- 7.1 - Positivos. -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="textoRelatorio">7.1 - Positivos:</label>
                  <v-textarea v-model="relatorioExtensao.texto6" rows="1" auto-grow counter="500" :rules="rules500">
                  </v-textarea>
                </v-flex>
              </v-layout>
              <!-- 7.2 - Negativos. -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="textoRelatorio">7.2 - Negativos:</label>
                  <v-textarea v-model="relatorioExtensao.texto7" rows="1" auto-grow counter="500" :rules="rules500">
                  </v-textarea>
                </v-flex>
              </v-layout>

              <br>

              <br>

              <!--
          8) Equipe.
        -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="item">8) Equipe.</label>
                </v-flex>
              </v-layout>

              <!-- Tabela com os membros da equipe. -->
              <v-data-table :headers="headersIntegrantes" :items="relatorioExtensao.listaRelatorioParticipante"
                :items-per-page="-1" hide-default-footer :header-props="{ sortIcon: null }" readonly class="tabela">

                <!-- Formata o campo "Assessor". -->
                <template v-slot:item.assessor="props">{{ formatAssessor.format(props.item.assessor,
                  props.item.funcao.item) }}</template>

                <!-- Formata o campo "Data inicial". -->
                <template v-slot:item.dataInicial="props">{{ dates.format(props.item.dataInicial) }}</template>

                <!-- Formata o campo "Data final". -->
                <template v-slot:item.dataFinal="props">{{ dates.format(props.item.dataFinal) }}</template>

              </v-data-table>

              <br>

              <!--
          9) Formas de apoio.
        -->
              <v-layout row wrap justify-center>
                <v-flex xs12>
                  <label class="item">9) Formas de apoio</label>
                </v-flex>
              </v-layout>

              <!-- 9.1 - A ação de extensão recebeu apoio da ProEx? -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <v-radio-group v-model="relatorioExtensao.opcao1" id="v-radio-group_label_9" class="v-radio-group_label"
                    label="9.1 - A ação de extensão recebeu apoio da ProEx?">
                    <v-radio label="Sim" value="S"></v-radio>
                    <v-radio label="Não" value="N"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <div v-if="relatorioExtensao.opcao1 === 'S'">
                <v-layout row wrap text-xs-left>
                  <v-flex xs12>
                    <label class="textoRelatorioSubitem">Especifique a(s) forma(s) de apoio:</label>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao1 !== 'S'"
                      v-model="relatorioExtensao.boolean1_1"><template v-slot:label>
                        <div class="v-checkbox_label">Bolsa</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao1 !== 'S'"
                      v-model="relatorioExtensao.boolean1_2"><template v-slot:label>
                        <div class="v-checkbox_label">Passagem</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao1 !== 'S'"
                      v-model="relatorioExtensao.boolean1_3"><template v-slot:label>
                        <div class="v-checkbox_label">Diária</div>
                      </template></v-checkbox></v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao1 !== 'S'"
                      v-model="relatorioExtensao.boolean1_4"><template v-slot:label>
                        <div class="v-checkbox_label">Material de consumo</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao1 !== 'S'"
                      v-model="relatorioExtensao.boolean1_5"><template v-slot:label>
                        <div class="v-checkbox_label">Material permanente</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao1 !== 'S'"
                      v-model="relatorioExtensao.boolean1_6"><template v-slot:label>
                        <div class="v-checkbox_label">Recurso financeiro</div>
                      </template></v-checkbox></v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao1 !== 'S'"
                      v-model="relatorioExtensao.boolean1_7"><template v-slot:label>
                        <div class="v-checkbox_label">Espaço físico</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao1 !== 'S'"
                      v-model="relatorioExtensao.boolean1_8"><template v-slot:label>
                        <div class="v-checkbox_label">Divulgação</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao1 !== 'S'"
                      v-model="relatorioExtensao.boolean1_9"><template v-slot:label>
                        <div class="v-checkbox_label">Transporte</div>
                      </template></v-checkbox></v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs11 sm4><v-checkbox :disabled="relatorioExtensao.opcao1 !== 'S'"
                      v-model="relatorioExtensao.boolean1_10"><template v-slot:label>
                        <div class="v-checkbox_label">Outros</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs11 sm6>
                    <v-textarea :disabled="(relatorioExtensao.opcao1 !== 'S' || relatorioExtensao.boolean1_10 !== true)"
                      label="Especifique:" v-model="relatorioExtensao.texto14" rows="1" auto-grow counter="200"
                      :rules="rules200" placeholder=" ">
                    </v-textarea>
                  </v-flex>
                </v-layout>
                <br>
              </div>

              <!-- 9.2 - A ação de extensão recebeu apoio de outras instituições e/ou órgãos de fomento nacionais, internacionais ou estrangeiros? -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <v-radio-group v-model="relatorioExtensao.opcao2" id="v-radio-group_label_9" class="v-radio-group_label"
                    label="9.2 - A ação de extensão recebeu apoio de outras instituições e/ou órgãos de fomento nacionais, internacionais ou estrangeiros?">
                    <v-radio label="Sim" value="S"></v-radio>
                    <v-radio label="Não" value="N"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <div v-if="relatorioExtensao.opcao2 === 'S'">
                <v-layout row wrap text-xs-left>
                  <v-flex xs12>
                    <label class="textoRelatorioSubitem">Especifique a(s) forma(s) de apoio:</label>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao2 !== 'S'"
                      v-model="relatorioExtensao.boolean2_1"><template v-slot:label>
                        <div class="v-checkbox_label">Bolsa</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao2 !== 'S'"
                      v-model="relatorioExtensao.boolean2_2"><template v-slot:label>
                        <div class="v-checkbox_label">Passagem</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao2 !== 'S'"
                      v-model="relatorioExtensao.boolean2_3"><template v-slot:label>
                        <div class="v-checkbox_label">Diária</div>
                      </template></v-checkbox></v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao2 !== 'S'"
                      v-model="relatorioExtensao.boolean2_4"><template v-slot:label>
                        <div class="v-checkbox_label">Material de consumo</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao2 !== 'S'"
                      v-model="relatorioExtensao.boolean2_5"><template v-slot:label>
                        <div class="v-checkbox_label">Material permanente</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao2 !== 'S'"
                      v-model="relatorioExtensao.boolean2_6"><template v-slot:label>
                        <div class="v-checkbox_label">Recurso financeiro</div>
                      </template></v-checkbox></v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao2 !== 'S'"
                      v-model="relatorioExtensao.boolean2_7"><template v-slot:label>
                        <div class="v-checkbox_label">Espaço físico</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao2 !== 'S'"
                      v-model="relatorioExtensao.boolean2_8"><template v-slot:label>
                        <div class="v-checkbox_label">Divulgação</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs4><v-checkbox :disabled="relatorioExtensao.opcao2 !== 'S'"
                      v-model="relatorioExtensao.boolean2_9"><template v-slot:label>
                        <div class="v-checkbox_label">Transporte</div>
                      </template></v-checkbox></v-flex>
                </v-layout>
                <v-layout>
                  <v-flex xs11 sm4><v-checkbox :disabled="relatorioExtensao.opcao2 !== 'S'"
                      v-model="relatorioExtensao.boolean2_10"><template v-slot:label>
                        <div class="v-checkbox_label">Outros</div>
                      </template></v-checkbox></v-flex>
                  <v-flex xs11 sm6>
                    <v-textarea :disabled="(relatorioExtensao.opcao2 !== 'S' || relatorioExtensao.boolean2_10 !== true)"
                      label="Especifique:" v-model="relatorioExtensao.texto15" rows="1" auto-grow counter="200"
                      :rules="rules200" placeholder=" ">
                    </v-textarea>
                  </v-flex>
                </v-layout>
                <br>
              </div>

              <!-- Formatação entre os itens 9.2 e 9.3 -->
              <div
                v-if="(relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 === true) && (relatorioExtensao.opcao2 === null || relatorioExtensao.opcao2 === 'N')">
                <br>
              </div>

              <!-- 9.3 - Os recursos financeiros indicados no(s) item(ns) 9.1 e/ou 9.2 foram executados por: -->
              <div
                v-if="(relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 === true) || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 === true)">
                <br>
                <v-layout row wrap text-xs-left>
                  <v-flex xs12>

                    <!-- Recurso financeiro indicado apenas no item 9.1. -->
                    <label class="textoRelatorio"
                      v-if="(relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 === true) && (relatorioExtensao.opcao2 === 'N' || relatorioExtensao.boolean2_6 === false)">
                      9.3 - Os recursos financeiros indicados no item 9.1 foram executados por:
                    </label>

                    <!-- Recurso financeiro indicado apenas no item 9.2. -->
                    <label class="textoRelatorio"
                      v-if="(relatorioExtensao.opcao1 === 'N' || relatorioExtensao.boolean1_6 === false) && (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 === true)">
                      9.3 - Os recursos financeiros indicados no item 9.2 foram executados por:
                    </label>

                    <!-- Recurso financeiro indicado nos itens 9.1 e 9.2. -->
                    <label class="textoRelatorio"
                      v-if="(relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 === true) && (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 === true)">
                      9.3 - Os recursos financeiros indicados nos itens 9.1 e 9.2 foram executados por:
                    </label>

                  </v-flex>
                </v-layout>
                <br>
                <v-layout>

                  <!-- UFES -->
                  <v-flex xs6 sm2>
                    <v-checkbox
                      :disabled="(relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true))"
                      v-model="relatorioExtensao.boolean3_1">
                      <template v-slot:label>
                        <div class="v-checkbox_label">UFES</div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs6 sm2>
                    <v-text-field-money v-model="relatorioExtensao.valor3_1" label="Valor (R$):" v-bind:properties="{
                      disabled: (relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true)) || relatorioExtensao.boolean3_1 !== true,
                      placeholder: ' ',
                    }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
                  </v-flex>

                  <v-flex xs0 sm2></v-flex>

                  <!-- CNPq -->
                  <v-flex xs6 sm2>
                    <v-checkbox
                      :disabled="(relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true))"
                      v-model="relatorioExtensao.boolean3_2">
                      <template v-slot:label>
                        <div class="v-checkbox_label">CNPq</div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs6 sm2>
                    <v-text-field-money v-model="relatorioExtensao.valor3_2" label="Valor (R$):" v-bind:properties="{
                      disabled: (relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true)) || relatorioExtensao.boolean3_2 !== true,
                      placeholder: ' ',
                    }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
                  </v-flex>

                </v-layout>

                <v-layout>

                  <!-- CAPES -->
                  <v-flex xs6 sm2>
                    <v-checkbox
                      :disabled="(relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true))"
                      v-model="relatorioExtensao.boolean3_3">
                      <template v-slot:label>
                        <div class="v-checkbox_label">CAPES</div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs6 sm2>
                    <v-text-field-money v-model="relatorioExtensao.valor3_3" label="Valor (R$):" v-bind:properties="{
                      disabled: (relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true)) || relatorioExtensao.boolean3_3 !== true,
                      placeholder: ' ',
                    }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
                  </v-flex>

                  <v-flex xs0 sm2></v-flex>

                  <!-- FAPES -->
                  <v-flex xs6 sm2>
                    <v-checkbox
                      :disabled="(relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true))"
                      v-model="relatorioExtensao.boolean3_4">
                      <template v-slot:label>
                        <div class="v-checkbox_label">FAPES</div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs6 sm2>
                    <v-text-field-money v-model="relatorioExtensao.valor3_4" label="Valor (R$):" v-bind:properties="{
                      disabled: (relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true)) || relatorioExtensao.boolean3_4 !== true,
                      placeholder: ' ',
                    }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
                  </v-flex>

                </v-layout>

                <v-layout>

                  <!-- FEST -->
                  <v-flex xs6 sm2>
                    <v-checkbox
                      :disabled="(relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true))"
                      v-model="relatorioExtensao.boolean3_5">
                      <template v-slot:label>
                        <div class="v-checkbox_label">FEST</div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs6 sm2>
                    <v-text-field-money v-model="relatorioExtensao.valor3_5" label="Valor (R$):" v-bind:properties="{
                      disabled: (relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true)) || relatorioExtensao.boolean3_5 !== true,
                      placeholder: ' ',
                    }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
                  </v-flex>

                  <v-flex xs0 sm2></v-flex>

                  <!-- FUCAM -->
                  <v-flex xs6 sm2>
                    <v-checkbox
                      :disabled="(relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true))"
                      v-model="relatorioExtensao.boolean3_6">
                      <template v-slot:label>
                        <div class="v-checkbox_label">FUCAM</div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs6 sm2>
                    <v-text-field-money v-model="relatorioExtensao.valor3_6" label="Valor (R$):" v-bind:properties="{
                      disabled: (relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true)) || relatorioExtensao.boolean3_6 !== true,
                      placeholder: ' ',
                    }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
                  </v-flex>

                </v-layout>

                <v-layout>

                  <!-- Outros -->
                  <v-flex xs6 sm2>
                    <v-checkbox
                      :disabled="(relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true))"
                      v-model="relatorioExtensao.boolean3_7">
                      <template v-slot:label>
                        <div class="v-checkbox_label">Outros</div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs6 sm5>
                    <v-textarea
                      :disabled="(relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true)) || relatorioExtensao.boolean3_7 !== true"
                      label="Especifique:" v-model="relatorioExtensao.texto16" rows="1" auto-grow counter="200"
                      :rules="rules200" placeholder=" ">
                    </v-textarea>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs6 sm2>
                    <v-text-field-money v-model="relatorioExtensao.valor3_7" label="Valor (R$):" v-bind:properties="{
                      disabled: (relatorioExtensao.opcao1 !== 'S' || (relatorioExtensao.opcao1 === 'S' && relatorioExtensao.boolean1_6 !== true)) && (relatorioExtensao.opcao2 !== 'S' || (relatorioExtensao.opcao2 === 'S' && relatorioExtensao.boolean2_6 !== true)) || relatorioExtensao.boolean3_7 !== true,
                      placeholder: ' ',
                    }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
                  </v-flex>
                  <v-flex xs6 sm2></v-flex>

                </v-layout>
                <br>
              </div>

              <!--
          10) Houve cobrança de taxa de inscrição, participação, visitação ou similar?
        -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <v-radio-group v-model="relatorioExtensao.opcao4" id="v-radio-group_label"
                    class="v-radio-group_label, item"
                    label="10) Houve cobrança de taxa de inscrição, participação, visitação ou similar?">
                    <v-radio class="opcaoRadio" label="Sim" value="S"></v-radio>
                    <v-radio class="opcaoRadio" label="Não" value="N"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <div v-if="relatorioExtensao.opcao4 === 'S'">
                <v-layout row wrap justify-center>
                  <v-flex xs12>
                    <label class="textoRelatorio">Os recursos financeiros foram administrados por:</label>
                  </v-flex>
                </v-layout>
                <br>

                <!-- UFES -->
                <v-layout>
                  <v-flex xs11 sm2>
                    <v-checkbox :disabled="relatorioExtensao.opcao4 !== 'S'" v-model="relatorioExtensao.boolean4_1">
                      <template v-slot:label>
                        <div class="v-checkbox_label">UFES</div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs11 sm2>
                    <v-text-field-money v-model="relatorioExtensao.valor4_1" label="Valor (R$):" v-bind:properties="{
                      disabled: (relatorioExtensao.opcao4 !== 'S' || relatorioExtensao.boolean4_1 !== true),
                      placeholder: ' ',
                    }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
                  </v-flex>
                </v-layout>

                <!-- FEST -->
                <v-layout>
                  <v-flex xs11 sm2>
                    <v-checkbox :disabled="relatorioExtensao.opcao4 !== 'S'" v-model="relatorioExtensao.boolean4_2">
                      <template v-slot:label>
                        <div class="v-checkbox_label">FEST</div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs11 sm2>
                    <v-text-field-money v-model="relatorioExtensao.valor4_2" label="Valor (R$):" v-bind:properties="{
                      disabled: (relatorioExtensao.opcao4 !== 'S' || relatorioExtensao.boolean4_2 !== true),
                      placeholder: ' ',
                    }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
                  </v-flex>
                </v-layout>

                <!-- FUCAM -->
                <v-layout>
                  <v-flex xs11 sm2>
                    <v-checkbox :disabled="relatorioExtensao.opcao4 !== 'S'" v-model="relatorioExtensao.boolean4_3">
                      <template v-slot:label>
                        <div class="v-checkbox_label">FUCAM</div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs11 sm2>
                    <v-text-field-money v-model="relatorioExtensao.valor4_3" label="Valor (R$):" v-bind:properties="{
                      disabled: (relatorioExtensao.opcao4 !== 'S' || relatorioExtensao.boolean4_3 !== true),
                      placeholder: ' ',
                    }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
                  </v-flex>
                </v-layout>

                <!-- Outros -->
                <v-layout>
                  <v-flex xs11 sm2>
                    <v-checkbox :disabled="relatorioExtensao.opcao4 !== 'S'" v-model="relatorioExtensao.boolean4_4">
                      <template v-slot:label>
                        <div class="v-checkbox_label">Outros</div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-textarea :disabled="(relatorioExtensao.opcao4 !== 'S' || relatorioExtensao.boolean4_4 !== true)"
                      label="Especifique:" v-model="relatorioExtensao.texto17" rows="1" auto-grow counter="200"
                      :rules="rules200" placeholder=" ">
                    </v-textarea>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs11 sm2>
                    <v-text-field-money v-model="relatorioExtensao.valor4_4" label="Valor (R$):" v-bind:properties="{
                      disabled: (relatorioExtensao.opcao4 !== 'S' || relatorioExtensao.boolean4_4 !== true),
                      placeholder: ' ',
                    }" v-bind:options="{
  locale: 'pt-BR',
  length: 13,
  precision: 2,
  empty: null,
}" />
                  </v-flex>
                  <v-flex xs6 sm2>
                  </v-flex>
                </v-layout>
              </div>

              <br>

              <br>

              <!--
          11) Informar as parcerias/colaborações: contatos nacionais e internacionais efetivamente ocorridos em função da atividade, como convênios, acordos de colaboração e outros.
        -->
              <v-layout row wrap justify-center>
                <v-flex xs12>
                  <label class="item">11) Informar as parcerias/colaborações: contatos nacionais e internacionais
                    efetivamente ocorridos em função da atividade, como convênios, acordos de colaboração e
                    outros.</label>
                </v-flex>
              </v-layout>

              <!-- Mensagem para instruir o usuário sobre as parcerias/colaborações a serem informadas -->
              <v-layout row wrap text-xs-left v-if="listaParcerias.length !== 0">
                <v-flex xs12>
                  <v-alert class="alertaEdicao" dense type="info" color="#00796b" outlined>
                    Primeiramente, adicione as parcerias/colaborações na aba "Parcerias". Em seguida, selecione-as na
                    lista abaixo.
                  </v-alert>
                </v-flex>
              </v-layout>

              <!-- Tabela com a lista de parcerias adicionadas na aba Parcerias -->
              <v-layout row wrap justify-center v-if="listaParcerias.length !== 0">
                <v-flex d-block xs12>
                  <c-checkbox-table :items="listaParcerias" v-model="listaParceriasSelecionadas"
                    :headers="headersParcerias" :opcoesPaginacao="opcoesPaginacao" :hideDefaultFooter="true"
                    :header-props="{ sortIcon: null }" :search="search" item-key="id" :selecionarTudo="false"
                    class="tabela">
                  </c-checkbox-table>
                </v-flex>
              </v-layout>

              <!-- Caso não existam parcerias adicionadas na aba Parcerias, exibe mensagem ao usuário -->
              <v-layout row wrap justify-center v-if="listaParcerias.length === 0">
                <v-flex xs12>
                  <v-alert class="alerta" color="#00796b" outlined>
                    Nenhuma parceria/colaboração foi informada na aba Parcerias
                  </v-alert>
                </v-flex>
              </v-layout>

              <br>
              <br>

              <!--
          12) Informar produtos de extensão.
        -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="item">12) Informar produtos de extensão</label>
                </v-flex>
              </v-layout>
              <br>
              <br>
              <!-- 12.1 - Trabalhos publicados e/ou aceitos para publicação no período, tais como livros, capítulos de livros, artigos em periódicos nacionais e internacionais, resumos em congressos, reuniões científicas e semelhantes. Indicar claramente entre os autores dos trabalhos, quando for o caso, os bolsistas e os voluntários. -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="textoRelatorio">12.1 - Trabalhos publicados e/ou aceitos para publicação no período, tais
                    como livros, capítulos de livros, artigos em periódicos nacionais e internacionais, resumos em
                    congressos, reuniões científicas e semelhantes. Indicar claramente entre os autores dos trabalhos,
                    quando for o caso, os bolsistas e os voluntários:</label>
                  <v-textarea v-model="relatorioExtensao.texto9" rows="1" auto-grow counter="500" :rules="rules500">
                  </v-textarea>
                </v-flex>
              </v-layout>
              <!-- 12.2 - Patente ou registro de invenção ou técnica (informar o título, se a patente é nacional, internacional ou “joint ventures” e outros dados que julgar adequados). -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="textoRelatorio">12.2 - Patente ou registro de invenção ou técnica (informar o título, se a
                    patente é nacional, internacional ou “joint ventures” e outros dados que julgar adequados):</label>
                  <v-textarea v-model="relatorioExtensao.texto10" rows="1" auto-grow counter="500" :rules="rules500">
                  </v-textarea>
                </v-flex>
              </v-layout>
              <!-- 12.3 - Outras atividades extensionistas, científicas ou administrativas que julgar pertinentes no período: organização ou participação em eventos científicos, consultorias, assessorias a órgãos de fomento, etc. -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="textoRelatorio">12.3 - Outras atividades extensionistas, científicas ou administrativas
                    que julgar pertinentes no período: organização ou participação em eventos científicos, consultorias,
                    assessorias a órgãos de fomento, etc:</label>
                  <v-textarea v-model="relatorioExtensao.texto11" rows="1" auto-grow counter="500" :rules="rules500">
                  </v-textarea>
                </v-flex>
              </v-layout>
              <!-- 12.4 - Premiações obtidas em função do desenvolvimento da atividade de extensão (título do prêmio, quem outorgou, data, local); honrarias acadêmicas. -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="textoRelatorio">12.4 - Premiações obtidas em função do desenvolvimento da atividade de
                    extensão (título do prêmio, quem outorgou, data, local); honrarias acadêmicas:</label>
                  <v-textarea v-model="relatorioExtensao.texto12" rows="1" auto-grow counter="500" :rules="rules500">
                  </v-textarea>
                </v-flex>
              </v-layout>
              <!-- 12.5 - Links para matérias jornalísticas sobre a ação. -->
              <v-layout row wrap text-xs-left>
                <v-flex xs12>
                  <label class="textoRelatorio">12.5 - Links para matérias jornalísticas sobre a ação:</label>
                  <v-textarea v-model="relatorioExtensao.texto13" rows="1" auto-grow counter="500" :rules="rules500">
                  </v-textarea>
                </v-flex>
              </v-layout>

              <br>

              <br>

              <!--
          13) Anexar materiais que comprovem a execução da ação de extensão, como: fotografias, livros, cartazes, panfletos, folders, manuais e outros.
        -->
              <v-layout row wrap justify-center>
                <v-flex xs12>
                  <label class="item">13) Anexar materiais que comprovem a execução da ação de extensão, como:
                    fotografias, livros, cartazes, panfletos, folders, manuais e outros:</label>
                </v-flex>
              </v-layout>

              <!-- Mensagem para instruir o usuário sobre os materiais a serem anexados. -->
              <v-layout row wrap text-xs-left v-if="listaArquivos.length !== 0">
                <v-flex xs12>
                  <v-alert class="alertaEdicao" dense type="info" color="#00796b" outlined>
                    Primeiramente, adicione os materiais desejados na aba "Arquivos". Em seguida, selecione-os na lista
                    abaixo.
                  </v-alert>
                </v-flex>
              </v-layout>

              <!-- Tabela com a lista de arquivos adicionados na aba Arquivos -->
              <v-layout row wrap justify-center v-if="listaArquivos.length !== 0">
                <v-flex d-block xs12>
                  <c-checkbox-table :items="listaArquivos" v-model="listaArquivosSelecionados" :headers="headers"
                    :hideDefaultFooter="true" :header-props="{ sortIcon: null }" :opcoesPaginacao="opcoesPaginacao"
                    :search="search" item-key="idArquivo" :selecionarTudo="false" class="tabela">
                  </c-checkbox-table>
                </v-flex>
              </v-layout>

              <!-- Caso não existam materiais anexados na aba Arquivos, exibe mensagem ao usuário -->
              <v-layout row wrap justify-center v-if="listaArquivos.length === 0">
                <v-flex xs12>
                  <v-alert class="alerta" color="#00796b" outlined>
                    Nenhum material foi anexado na aba Arquivos
                  </v-alert>
                </v-flex>
              </v-layout>

              <br>
              <br>

            </v-form>

            <br>

            <v-divider></v-divider>

            <v-card-actions>

              <!-- Botão "Cancelar" -->
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Botão "Salvar" -->
              <v-btn color="primary" text @click="salvarRelatorioExtensao(false)"
                :disabled="!formularioValido">Salvar</v-btn>

              <!-- Botão "Salvar e Voltar" -->
              <v-btn color="primary" text @click="salvarRelatorioExtensao(true)" :disabled="!formularioValido">Salvar e
                Voltar</v-btn>

            </v-card-actions>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CheckboxTable from '@/components/c-checkbox-table'
import DataMenu from '@/components/c-date-menu'
import DataMenuNoIcon from '@/components/c-date-menu-no-icon'
import ReadonlyField from '@/components/c-readonly-field'
import SoloTextField from '@/components/c-solo-text-field'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import formatAssessor from '@/utils/assessor'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import situacaoAtividade from '@/utils/situacaoAtividade'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['idProjeto', 'idRelatorioExtensao'],
  data: () => ({
    dates: dates,
    formatAssessor: formatAssessor,
    situacaoAtividade: situacaoAtividade,
    listaTipoRelatorio: [{ descricao: 'Parcial' }, { descricao: 'Final' }],
    listaTipoRelatorio2: [{ descricao: 'Final' }],
    listaArquivos: [],
    listaParcerias: [],
    listaArquivosSelecionados: [],
    listaParceriasSelecionadas: [],
    projeto: {
      classificacoesPrimariaSecundaria: [{}, {}]
    },
    rules750: [
      (input) => input.length <= 750 || 'Este campo não pode possuir mais que 750 caracteres'
    ],
    rules300: [
      (input) => input.length <= 300 || 'Este campo não pode possuir mais que 300 caracteres'
    ],
    rules1000: [
      (input) => input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres'
    ],
    rules500: [
      (input) => input.length <= 500 || 'Este campo não pode possuir mais que 500 caracteres'
    ],
    rules200: [
      (input) => input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres'
    ],
    numerico: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !isNaN(input) || 'Este campo deve ser numérico',
      (input) => (input.length === 0 || Number(input) !== 0) || 'Este campo não pode ser nulo',
      (input) => (input.length === 0 || Number(input) >= 0) || 'Este campo não pode ter valor negativo'
    ],
    foraDoPrazo: null,
    relatorioForaPrazo: false,
    relatorioExtensao: {},
    periodoRelatorio: {},
    tipoRelatorioTecnicoItemInicial: 0,
    dtInicialFormatada: '',
    dtFinalFormatada: '',
    dtAprovacaoFormatada: '',
    dtReprovacaoFormatada: '',
    formularioValido: false,
    search: null,
    headersIntegrantes: [
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Função', align: 'left', value: 'funcao.descricao' },
      { text: 'Vínculo', align: 'left', value: 'vinculo' },
      { text: 'CH semanal', align: 'left', value: 'cargaHoraria' },
      { text: 'Data inicial', align: 'left', value: 'dataInicial' },
      { text: 'Data final', align: 'left', value: 'dataFinal' }
    ],
    headersParcerias: [
      { checkbox: true, sortable: false, value: 'checkbox' },
      { text: 'Nome do parceiro institucional/colaborador', align: 'left', value: 'nome' },
      { text: 'Descrição da parceria/colaboração', align: 'left', value: 'detalhamento' }
    ],
    headers: [
      { checkbox: true, sortable: false, value: 'checkbox' },
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Tipo', align: 'left', value: 'tipoArquivo.descricao' },
      { text: 'Descrição', left: 'left', value: 'observacao' }
    ],
    opcoesPaginacao: [{ text: 'Todas', value: -1 }]
  }),
  computed: {
    ...mapGetters('auth', ['administrador']),
    cursoOuEvento: function () {
      return (this.projeto.classificacaoSecundaria.id === 39729 || this.projeto.classificacaoSecundaria.id === 44194 || this.projeto.classificacaoSecundaria.id === 44195 || this.projeto.classificacaoSecundaria.id === 39730)
    }
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    salvarRelatorioExtensao: function (retorna) {
      console.log(this.listaArquivosSelecionados)
      console.log(this.listaParceriasSelecionadas)
      this.relatorioExtensao.listaRelatorioArquivo = []
      this.relatorioExtensao.listaRelatorioParceria = []
      for (let aux in this.listaArquivosSelecionados) {
        this.relatorioExtensao.listaRelatorioArquivo.push({ idArquivo: this.listaArquivosSelecionados[aux] })
      }
      for (let aux2 in this.listaParceriasSelecionadas) {
        this.relatorioExtensao.listaRelatorioParceria.push({ id: this.listaParceriasSelecionadas[aux2] })
      }

      // Limpa campo caso o item "1) A metodologia foi alterada para alcançar os objetivos da proposta inicial?" seja 'Não'.
      if (this.relatorioExtensao.opcao5 === 'N') {
        this.relatorioExtensao.texto1 = null
      }

      // Limpa campos caso o item "9.1 - A ação de extensão recebeu apoio da ProEx?" seja 'Não'.
      if (this.relatorioExtensao.opcao1 === 'N') {
        this.relatorioExtensao.boolean1_1 = false
        this.relatorioExtensao.boolean1_2 = false
        this.relatorioExtensao.boolean1_3 = false
        this.relatorioExtensao.boolean1_4 = false
        this.relatorioExtensao.boolean1_5 = false
        this.relatorioExtensao.boolean1_6 = false
        this.relatorioExtensao.boolean1_7 = false
        this.relatorioExtensao.boolean1_8 = false
        this.relatorioExtensao.boolean1_9 = false
        this.relatorioExtensao.boolean1_10 = false
        this.relatorioExtensao.texto14 = null
      }

      // Limpa valor do campo "Outros" do item 9.1.
      if (this.relatorioExtensao.boolean1_10 === false) {
        this.relatorioExtensao.texto14 = null
      }

      // Limpa campos caso o item "9.2 - A ação de extensão recebeu apoio de outras instituições e/ou órgãos de fomento nacionais, internacionais ou estrangeiros?" seja 'Não'.
      if (this.relatorioExtensao.opcao2 === 'N') {
        this.relatorioExtensao.boolean2_1 = false
        this.relatorioExtensao.boolean2_2 = false
        this.relatorioExtensao.boolean2_3 = false
        this.relatorioExtensao.boolean2_4 = false
        this.relatorioExtensao.boolean2_5 = false
        this.relatorioExtensao.boolean2_6 = false
        this.relatorioExtensao.boolean2_7 = false
        this.relatorioExtensao.boolean2_8 = false
        this.relatorioExtensao.boolean2_9 = false
        this.relatorioExtensao.boolean2_10 = false
        this.relatorioExtensao.texto15 = null
      }

      // Limpa valor do campo "Outros" do item 9.2.
      if (this.relatorioExtensao.boolean2_10 === false) {
        this.relatorioExtensao.texto15 = null
      }

      // Limpa campos do item "9.3 - Os recursos financeiros indicados no(s) item(ns) 9.1 e/ou 9.2 foram executados por:".
      if ((this.relatorioExtensao.opcao1 === 'N' || this.relatorioExtensao.boolean1_6 === false) && (this.relatorioExtensao.opcao2 === 'N' || this.relatorioExtensao.boolean2_6 === false)) {
        this.relatorioExtensao.boolean3_1 = false
        this.relatorioExtensao.boolean3_2 = false
        this.relatorioExtensao.boolean3_3 = false
        this.relatorioExtensao.boolean3_4 = false
        this.relatorioExtensao.boolean3_5 = false
        this.relatorioExtensao.boolean3_6 = false
        this.relatorioExtensao.boolean3_7 = false
        this.relatorioExtensao.valor3_1 = null
        this.relatorioExtensao.valor3_2 = null
        this.relatorioExtensao.valor3_3 = null
        this.relatorioExtensao.valor3_4 = null
        this.relatorioExtensao.valor3_5 = null
        this.relatorioExtensao.valor3_6 = null
        this.relatorioExtensao.valor3_7 = null
        this.relatorioExtensao.texto16 = null
      }

      // Limpa valor do campo "UFES" do item 9.3.
      if (this.relatorioExtensao.boolean3_1 === false) {
        this.relatorioExtensao.valor3_1 = null
      }

      // Limpa valor do campo "CNPq" do item 9.3.
      if (this.relatorioExtensao.boolean3_2 === false) {
        this.relatorioExtensao.valor3_2 = null
      }

      // Limpa valor do campo "CAPES" do item 9.3.
      if (this.relatorioExtensao.boolean3_3 === false) {
        this.relatorioExtensao.valor3_3 = null
      }

      // Limpa valor do campo "FAPES" do item 9.3.
      if (this.relatorioExtensao.boolean3_4 === false) {
        this.relatorioExtensao.valor3_4 = null
      }

      // Limpa valor do campo "FEST" do item 9.3.
      if (this.relatorioExtensao.boolean3_5 === false) {
        this.relatorioExtensao.valor3_5 = null
      }

      // Limpa valor do campo "FUCAM" do item 9.3.
      if (this.relatorioExtensao.boolean3_6 === false) {
        this.relatorioExtensao.valor3_6 = null
      }

      // Limpa valor do campo "Outros" do item 9.3.
      if (this.relatorioExtensao.boolean3_7 === false) {
        this.relatorioExtensao.texto16 = null
        this.relatorioExtensao.valor3_7 = null
      }

      // Limpa campos caso o item "10) Houve cobrança de taxa de inscrição, participação, visitação ou similar?" seja 'Não'.
      if (this.relatorioExtensao.opcao4 === 'N') {
        this.relatorioExtensao.boolean4_1 = false
        this.relatorioExtensao.boolean4_2 = false
        this.relatorioExtensao.boolean4_3 = false
        this.relatorioExtensao.boolean4_4 = false
        this.relatorioExtensao.valor4_1 = null
        this.relatorioExtensao.valor4_2 = null
        this.relatorioExtensao.valor4_3 = null
        this.relatorioExtensao.valor4_4 = null
        this.relatorioExtensao.texto17 = null
      }

      // Limpa valor do campo "UFES" do item 10.
      if (this.relatorioExtensao.boolean4_1 === false) {
        this.relatorioExtensao.valor4_1 = null
      }

      // Limpa valor do campo "FEST" do item 10.
      if (this.relatorioExtensao.boolean4_2 === false) {
        this.relatorioExtensao.valor4_2 = null
      }

      // Limpa valor do campo "FUCAM" do item 10.
      if (this.relatorioExtensao.boolean4_3 === false) {
        this.relatorioExtensao.valor4_3 = null
      }

      // Limpa valor do campo "Outros" do item 10.
      if (this.relatorioExtensao.boolean4_4 === false) {
        this.relatorioExtensao.texto17 = null
        this.relatorioExtensao.valor4_4 = null
      }

      // Limpa valor do campo "Apresentar justificativa para envio do relatório fora do prazo."
      if (this.relatorioForaPrazo === false || this.foraDoPrazo === false) {
        this.relatorioExtensao.justificativaForaPrazo = null
      }

      // Edita o relatório técnico.
      this.editarRelatorioExtensao(retorna)
    },
    // Edita o relatório técnico.
    editarRelatorioExtensao: function (retorna) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando relatório de extensão.' })
      projetos.putRelatorioExtensao(this.idProjeto, this.idRelatorioExtensao, this.relatorioExtensao)
        .then(response => {
          this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem })
          if (retorna) {
            this.$router.push({ name: 'RelatorioTecnico', params: { idProjeto: this.idProjeto, idRelatorioExtensao: this.idRelatorioExtensao } })
          }
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem })
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Salvando relatório de extensão.' })
        })
    },
    // Retorna a situação do relatório.
    getSituacaoRelatorio: function (situacaoRelatorioTecnicoItem) {
      if (situacaoRelatorioTecnicoItem === 1) {
        return 'Em elaboração'
      } else if (situacaoRelatorioTecnicoItem === 2) {
        return 'Aguardando aprovação'
      } else if (situacaoRelatorioTecnicoItem === 3) {
        return 'Aprovado'
      } else if (situacaoRelatorioTecnicoItem === 4) {
        return 'Reprovado'
      } else {
        return 'Situação inválida'
      }
    }
  },
  mounted: function () {
    // Carrega a ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
    projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })

    // Carrega o relatório.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' })
    projetos.getRelatorioExtensao(this.idProjeto, this.idRelatorioExtensao)
      .then(response => {
        this.relatorioExtensao = response.data
        this.tipoRelatorioTecnicoItemInicial = this.relatorioExtensao.tipoRelatorioTecnicoItem
        this.dtInicialFormatada = dates.format(this.relatorioExtensao.dtInicial)
        this.dtFinalFormatada = dates.format(this.relatorioExtensao.dtFinal)
        this.dtAprovacaoFormatada = dates.format(this.relatorioExtensao.dtAprovacaoRelatorio)
        this.dtReprovacaoFormatada = dates.format(this.relatorioExtensao.dtReprovacaoRelatorio)
        this.listaArquivosSelecionados = []
        this.listaParceriasSelecionadas = []
        for (let aux in this.relatorioExtensao.listaRelatorioArquivo) {
          this.listaArquivosSelecionados.push(this.relatorioExtensao.listaRelatorioArquivo[aux].idArquivo)
        }
        for (let aux2 in this.relatorioExtensao.listaRelatorioParceria) {
          this.listaParceriasSelecionadas.push(this.relatorioExtensao.listaRelatorioParceria[aux2].id)
        }
        console.log(this.listaArquivosSelecionados)
        console.log(this.listaParceriasSelecionadas)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório.' })
      })

    // Carrega as parcerias da ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' })
    projetos.getParceriasDoProjeto(this.idProjeto)
      .then(response => {
        this.listaParcerias = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' })
      })

    // Carrega os arquivos da ação de extensão.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos.' })
    projetos.getArquivosDoProjeto(this.idProjeto)
      .then(response => {
        this.listaArquivos = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando arquivos.' })
      })

    // Endpoint que retorna se o relatório está fora do prazo para envio.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' })
    projetos.getRelatorioTecnicoForaPrazo(this.idProjeto, this.idRelatorioExtensao)
      .then(response => {
        this.relatorioForaPrazo = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando informações adicionais.' })
      })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-date-menu': DataMenu,
    'c-date-menu-no-icon': DataMenuNoIcon,
    'c-solo-text-field': SoloTextField,
    'c-readonly-field': ReadonlyField,
    'c-checkbox-table': CheckboxTable
  }
}
</script>

<style lang="css" scoped>
.v-text-field>>>label {
  font-size: 14pt;
}

.v-radio>>>label {
  font-size: 1.0em;
}

.alertaEdicao {
  margin: 1.6em 0 2.0em 0;
  font-size: 1.10em
}

.alertaEdicao a {
  text-decoration: underline;
}

.alerta {
  margin: 1.6em 0 2.0em 0;
  font-size: 1.10em;
  text-align: center;
}
</style>

<style lang="css">
#v-radio-group_label {
  font-size: 1.0em;
}

#v-radio-group_label_9 {
  font-size: 1.05em;
}

.v-checkbox_label {
  font-size: 0.95em;
}

th.objetivoEspecifico,
th.resultados {
  width: 50%
}

.box {
  text-align: center;
  margin-top: 2em;
  margin-bottom: 2em;
}

.item {
  font-weight: bold;
  font-size: 1.25em;
}

.textoRelatorio {
  font-size: 1.25em;
}

.textoRelatorioSubitem {
  font-size: 1.15em;
}

.opcaoRadio {
  font-weight: normal;
}

.tabela {
  margin-top: 15px;
  margin-bottom: 20px;
}

.tabela th {
  font-weight: bold !important;
  font-size: 1.1em !important;
}

.tabela td {
  font-size: 1.1em !important;
}
</style>



// WEBPACK FOOTER //
// editar-relatorio.vue?01efb258